/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

const Routes = {
  landingPage: "/",
  login: "/login",
  logout: "/logout",
  dashboard: "/dashboard",
  forgotPasswordPage: "/forgot-password",
  resetPasswordPage: "/resetpassword",
  resetPasswordSuccess: "/resetpasswordsuccess",
  userMgmtPage: "/user-list",
  companyMgmtPage: "/company-list",
  resetPasswordGen: "/resetpassword",
  createPipe: "/create-pipe",
  editPipe: "/edit-pipe",
  viewPipe: "/view-pipe",
  adminSettings: "/billing-usage",
  changePassword: "/change-password",
  collectorList: "/collector-list",
  connectorList: "/connector-list",
  datapipeList: "/data-pipe-list",
  createCollector: "/create-collector",
  createConnector: "/create-connector",
  editCollector: "/edit-collector",
  editConnector: "/edit-connector",
  signup: "/signup",
  completeSignup: "/complete-registration",
  pendingApproval: "/pending-approval",
  platformSettings: "/platform-settings",
  rate_cards: "/rate-cards",
  payment: "/payment",
  deleteConnector: "/delete-connector",
  deleteCollector: "/delete-collector",
  deleteDatapipe: "/delete-datapipe",
  data_dictionary: "/data-point-management",
  projects: "/projects",
  collectorConfiguration: "/collector-configuration",
  connectorConfiguration: "/connector-configuration",
  custom_data: "/custom-data",
  companies: "/companies",
  users: "/users",
  collector_management: "/collector-management",
  data_pipe_details: "/data-pipe-details",
  create_datapipe: "/create-data-pipe",
  signin: "/signin",
  epg_enrichment: "/epg-enrichment",
};

export default Routes;
